// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"Q7-z"};